import { render, staticRenderFns } from "./VouchersList.vue?vue&type=template&id=2d178f91"
import script from "./VouchersList.vue?vue&type=script&lang=js"
export * from "./VouchersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports